import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { BuyBoxFilterOptions } from '@/stores/user.store';
import { useUserStore, useRoutingStore } from '@/helpers/composables/useStores';
import { useI18n } from '@/helpers/composables/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxFilterNew',
  props: {
    buyBoxFilterOptions: null,
    defaultBuyboxType: null,
    additionalContexts: null,
    isTitleUpcoming: { type: Boolean },
    episodeBuyBoxType: null
  },
  emits: ["filterClicked"],
  setup(__props: any, { emit }: { emit: ({
	(
		e: 'filterClicked',
		{
			value,
			nonInteraction,
		}: {
			value: BuyBoxFilterOptions;
			nonInteraction?: boolean;
		}
	): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	buyBoxFilterOptions: BuyBoxFilterOptions[];
	defaultBuyboxType?: BuyBoxFilterOptions;
	additionalContexts: SnowplowContext[];
	isTitleUpcoming: boolean;
	episodeBuyBoxType?: BuyBoxFilterOptions | null;
};

const HiddenHorizontalScrollbar = () => import('@/components/HiddenHorizontalScrollbar.vue');

const { tc } = useI18n();

const { newBuyboxFilterType } = useUserStore();
const { activeRoute } = useRoutingStore();



const buyboxFilterType = computed<BuyBoxFilterOptions>(() => props.episodeBuyBoxType ?? newBuyboxFilterType.value);



const filterOptions = computed(() => {
	const options = [
		{
			label: tc('WEBAPP_ALL'),
			value: BuyBoxFilterOptions.ALL,
		},
		{
			label: tc('WEBAPP_SUBSCRIPTION'),
			value: BuyBoxFilterOptions.SUBSCRIPTION,
		},
		{
			label: tc('WEBAPP_FREE'),
			value: BuyBoxFilterOptions.FREE,
		},
		{
			label: tc('WEBAPP_FREE_TV'),
			value: BuyBoxFilterOptions.FAST_TV,
		},
		{
			label: tc('WEBAPP_RENT'),
			value: BuyBoxFilterOptions.RENT,
		},
		{
			label: tc('WEBAPP_BUY'),
			value: BuyBoxFilterOptions.BUY,
		},
		{
			label: tc('WEBAPP_CINEMA'),
			value: BuyBoxFilterOptions.CINEMA,
		},
	];

	return options.filter(option => {
		return (
			props.buyBoxFilterOptions.includes(option.value) ||
			[
				BuyBoxFilterOptions.ALL,
				props.isTitleUpcoming ? BuyBoxFilterOptions.SUBSCRIPTION : null,
				BuyBoxFilterOptions.FREE,
			].includes(option.value)
		);
	});
});

const handleFilterClick = (value: BuyBoxFilterOptions) => {
	emit('filterClicked', { value });
};

onMounted(() => {
	if (activeRoute.value.query.monetization_types === 'free') {
		emit('filterClicked', { value: BuyBoxFilterOptions.FREE, nonInteraction: true });
		return;
	}

	if (!filterOptions.value.find(filterOption => filterOption.value === props.defaultBuyboxType)) {
		emit('filterClicked', { value: BuyBoxFilterOptions.ALL, nonInteraction: true });
		return;
	}
});

return { __sfc: true,HiddenHorizontalScrollbar, tc, newBuyboxFilterType, activeRoute, props, buyboxFilterType, emit, filterOptions, handleFilterClick }
}

})